module.exports = __webpack_public_path__ + "img/seedpaper-berry-gloss.c3e12347.png";